<template>
    <ul class="nav justify-content-center pt-4 pb-5 settings-nav">
        <!-- <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'account.settings.alerts' }">
                <div class="nav-img">
                    <img :src="warning" class="img-fluid" alt="">
                </div>
                Alerts
            </router-link>
        </li> -->
        <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'account.settings.change-password' }">
                <div class="nav-img">
                    <img :src="lock" class="img-fluid" alt="">
                </div>
                <span class="hide">Change</span> Password
            </router-link>
        </li>
        <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'account.settings.change-compaany-account' }">
                <div class="nav-img">
                    <img :src="lock" class="img-fluid" alt="">
                </div>
                <span class="hide">Change</span> Company Account
            </router-link>
        </li>
        <li class="nav-item">
            <router-link class="nav-link" :to="{ name: 'dashboard' }">
                <div class="nav-img">
                    <img :src="back" class="img-fluid" alt="">
                </div>
                Back<span class="hide"> to Dashboard</span>
            </router-link>
        </li>
    </ul>
</template>

<style scoped>
	.settings-nav .nav-item {
		margin: 0px 20px;
	}

	.settings-nav .nav-item .nav-link {
		text-align: center;
	}

	.settings-nav .nav-img {
		width: 40px;
		margin: auto;
		margin-bottom: 10px;
	}

	@media (max-width: 425px) {
		.settings-nav .nav-item {
			margin: 0px 3px;
		}

		.settings-nav .nav-img {
			width: 20px;
			margin-bottom: 0px;
		}

		.hide {
			display: none;
		}
	}
</style>

<script>
import lock from '../../../../../../img/lock.svg'
import back from '../../../../../../img/return.svg'
import warning from '../../../../../../img/warning.svg'

export default {
    data() {
        return {
            warning,
            lock,
            back
        };
    }
}
</script>
